/* import __COLOCATED_TEMPLATE__ from './sh-linear-select.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';

export default Component.extend({
  classNames: 'linear-select',

  // can be an array of strings, numbers, or an object like { value: 'some value', label: 'Label to Display'}
  // can be mixed content
  items: [],
  action: undefined,

  initialIdx: 0,
  selectedIdx: undefined,

  init() {
    this._super(...arguments);
    this.set('selectedIdx', this.get('initialIdx'));
  },

  labels: computed('items', function() {
    const items = this.get('items');
    return items.map(item => (typeof item === 'object') ? item.label : item);
  }),

  actions: {
    executeAction(idx) {
      const item = this.get('items')[idx];
      const value = (typeof item === 'object') ? item.value : item;

      this.get('action')(value, idx);
      this.set('selectedIdx', idx);
    }
  }
});
